'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = require('./map.html');

var _map2 = _interopRequireDefault(_map);

var _map3 = require('./map.controller');

var _map4 = _interopRequireDefault(_map3);

require('./map.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapComponent = {
  bindings: {
    item: "=",
    language: "<",
    model: "<"
  },
  template: _map2.default,
  controller: _map4.default,
  controllerAs: "vm"
};

exports.default = mapComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/map/map.component.js